import { PageBackLink } from "@/components/page-back-link"
import { createFileRoute, Link } from "@tanstack/react-router"

import { PageBreadcrumbs, PageHeader } from "@/components/page-header"
import { StatusBadge } from "@/components/status-badge"

export const Route = createFileRoute("/dashboard/support/")({
	component: SupportPage,
})

export function SupportPage() {
	return (
		<div className="space-y-6">
			<PageHeader back={<PageBackLink to="/dashboard" label="Back to dashboard" />}
				breadcrumbs={
					<PageBreadcrumbs
						items={[
							<Link key="dashboard" to="/dashboard">
								Dashboard
							</Link>,
							<span key="support">Support</span>,
						]}
					/>
				}
				title="Support"
			/>

			<section className="rounded-2xl border border-border bg-card p-6 shadow-card">
				<div className="flex flex-wrap items-center gap-3">
					<h2 className="font-inter text-section-title font-semibold text-heading">
						Support tickets unavailable
					</h2>
					<StatusBadge>Not implemented</StatusBadge>
				</div>
				<p className="mt-3 max-w-2xl font-inter text-body text-muted-foreground">
					There is no support ticket service connected to the Portal. This page will not
					request or display ticket data until that backend capability exists.
				</p>
			</section>
		</div>
	)
}
